import React from "react";
import image from "./assests/IMAGE (1).png";
import image2 from "./assests/IMAGE (3).png";
import image3 from "./assests/IMAGE (2).png";
import "../style/vissionMission.css";
import visionImage from "./assests/VisionMission.png";

const VisionMission = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <img src={visionImage} />
        </div>
      </div>
      <div className="row mt-16">
        <div className="col-lg-5 col-md-4 col-sm-12">
          <img src={image} />
        </div>
        <div className="col-lg-7 col-md-8 col-sm-12">
          <h1 className="mission-header">MISSION</h1>
          <p className="mission-description">
            Our Mission is to shape young students to develop an active and
            creative mind who will then contribute to a knowledgeable and
            compassionate society. We will ensure total development of a child
            whitch is not just restricted toaccademic areas but extends to the
            cultural and co-curricular activities committed to empowering the
            child for excellience.
          </p>
        </div>
      </div>
      {/* 2nd row */}
      <div className="row">
        <div className="col-lg-7 col-md-8 col-sm-12">
          <h1 className="vission-header">VISION</h1>
          <p className="vision-description">
            To develop students who are sensitive, resilient, and able to
            navigate life with compassion and who will strive to create a
            harmonious society.
          </p>
        </div>
        <div className="col-lg-5 col-md-4 col-sm-12">
          <img src={image2} className="mt-10" />
        </div>
      </div>
      {/* 3rd row */}
      <div className="row mt-16">
        <div className="col-lg-6 col-md-4 col-sm-12">
          <img src={image3} />
        </div>
        <div className="col-lg-6 col-md-8 col-sm-12">
          <h2 className="our-moto">OUR MOTTO IS</h2>
          <h2 className="may-I">"MAY I SWERVE NOT FROM THE RIGHT PATH"</h2>
        </div>
      </div>
    </div>
  );
};

export default VisionMission;
